<template>
  <div>
    <div id="PengajuanManagement">
      <div class="row mb-4">
        <div class="col-sm-8">
          <h2>Ujrah</h2>
        </div>
      </div>

      <div class="row no-gutters mb-4">
        <div class="col-md-9">
          <label>Filter Berdasarkan Tanggal :</label>
          <div class="form-inline">
            <input
              name="start_date"
              type="text"
              onfocus="(this.type='date')"
              placeholder="Mulai Dari"
              class="form-control mr-2"
            />
            <input
              name="end_date"
              type="text"
              onfocus="(this.type='date')"
              placeholder="Sampai Dengan"
              class="form-control mr-2"
            />
            <b-button
              class="btn btn-custom rounded-5 btn-sm"
              @click="applyDateFilter"
              >Filter</b-button
            >
          </div>
        </div>
      </div>

      <div class="overflow-auto">
        <b-table
          id="pengajuan-table"
          responsive="true"
          :items="biayaJasaItems"
          :fields="biayaJasaFields"
          :current-page="currentPagePengajuan"
          :per-page="perPagePengajuan"
        >
          <template v-slot:cell(details)="data">
            <div align="center">
              {{
                data.item.details && Array.isArray(data.item.details)
                  ? data.item.details.length
                  : "-"
              }}
            </div>
          </template>
          <template v-slot:cell(month)="data">
            <div>
              {{ data.item.month ? formatBulan(data.item.month) : "-" }}
            </div>
          </template>

          <template v-slot:cell(totals)="data">
            <div class="d-flex justify-content-between">
              <span>Rp.</span>
              <span>
                {{
                  new Intl.NumberFormat("id-ID").format(
                    Number(data.item.totals)
                  )
                }}
              </span>
            </div>
          </template>

          <template v-slot:cell(biayas)="data">
            <div class="d-flex justify-content-between">
              <span>Rp.</span>
              <span>
                {{
                  new Intl.NumberFormat("id-ID").format(
                    Number(data.item.biayas)
                  )
                }}
              </span>
            </div>
          </template>

          <template v-slot:cell(status)="data">
            <div
              :style="{
                color:
                  data.item.status === 'approved'
                    ? 'green'
                    : data.item.status === 'uploaded'
                    ? 'orange'
                    : 'red',
                fontWeight: 'bold',
              }"
            >
              {{
                data.item.status === "approved"
                  ? "Diterima"
                  : data.item.status === "uploaded"
                  ? "Menunggu konfirmasi penerimaan"
                  : "Menunggu Pembayaran"
              }}
            </div>
          </template>

          <template v-slot:cell(aksi)="data">
            <b-button
              @click="openModal(data.item)"
              type="button"
              variant="primary"
              class="btn btn-custom theme-color rounded-5"
            >
              Detail
            </b-button>
            <b-button
              v-if="data.item.status === 'uploaded'"
              @click="openModalConfirmPayments(data.item)"
              type="button"
              variant="primary"
              class="btn btn-custom theme-color rounded-5"
            >
              Konfirmasi Pembayaran
            </b-button>
          </template>
        </b-table>
      </div>
      <NewCustomModal
        :visible="openDetailModal"
        @close="openDetailModal = false"
        size="large"
        with-logo
        title="Ujrah Agen Pemasaran"
      >
        <div class="flex-column">
          <!-- Bagian Ringkasan -->
          <div class="text-left">
            <p><strong>Bulan :</strong> {{ formatBulan(dataModal.month) }}</p>
            <p>
              <strong>Jumlah Pengajuan :</strong>
              {{ dataModal.details ? dataModal.details.length : "-" }}
            </p>
            <p>
              <strong>Total Penempatan Dana :</strong> Rp.
              {{ new Intl.NumberFormat("id-ID").format(dataModal.totals) }}
            </p>
            <p>
              <strong>Total Ujrah :</strong> Rp.
              {{ new Intl.NumberFormat("id-ID").format(dataModal.biayas) }}
            </p>
            <p>
              <strong>Status :</strong>
              <span
                :style="{
                  color:
                    dataModal.status === 'approved'
                      ? 'green'
                      : dataModal.status === 'uploaded'
                      ? 'orange'
                      : 'red',
                  fontWeight: 'bold',
                }"
              >
                {{
                  dataModal.status === "approved"
                    ? "Diterima"
                    : dataModal.status === "uploaded"
                    ? "Menunggu konfirmasi penerimaan"
                    : "Menunggu Pembayaran"
                }}
              </span>
            </p>
          </div>

          <!-- Bagian Detail Transaksi -->
          <h4 class="mb-3 text-center">Detail Transaksi</h4>
          <div style="overflow-x: auto; -webkit-overflow-scrolling: touch">
            <table class="table table-bordered" style="min-width: 1500px">
              <thead class="thead-light">
                <tr>
                  <th>Nama Produk</th>
                  <th>Kategori</th>
                  <th>Sub Kategori</th>
                  <th>Nama Nasabah</th>
                  <th>Penempatan Dana</th>
                  <th>Tanggal Aktif</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in dataModal.details" :key="index">
                  <td>{{ row.product }}</td>
                  <td>{{ row.product_category }}</td>
                  <td>{{ row.sub_product_category }}</td>
                  <td>{{ row.nasabah }}</td>
                  <td>
                    <div class="d-flex justify-content-between">
                      <span>Rp.</span>
                      <span>
                        {{
                          new Intl.NumberFormat("id-ID").format(
                            Number(row.setoran_awal)
                          )
                        }}
                      </span>
                    </div>
                  </td>
                  <td>{{ formatTanggal(row.started_at) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </NewCustomModal>
      <newCustomModal
        :visible="confirmPaymentModal"
        @close="confirmPaymentModal = false"
        with-logo
        title="Konfirmasi Penerimaan Pembayaran"
      >
        <div
          class="flex-column"
          style="
            align-items: center;
            justify-content: center;
            text-align: center;
          "
        >
          <img
            :src="imagePayment"
            alt="payment-confirmation"
            style="
              margin-bottom: 20px;
              border-radius: 10px;
              max-width: 100%;
              height: auto;
            "
          />

          <span class="text-value" style="color: #274c8e; font-size: 18px">
            Apakah Anda sudah menerima pembayaran tersebut?
          </span>

          <div class="modal-action-buttons" style="margin-top: 40px">
            <button
              class="custom-btn rekening danger"
              @click="onRejectPayment"
              :disabled="loadingPayment"
            >
              <template v-if="loadingPayment">
                <b-spinner
                  small
                  type="border"
                  variant="light"
                  class="mr-2"
                  label="Loading..."
                ></b-spinner>
                Memproses...
              </template>
              <template v-else> Belum </template>
            </button>
            <button
              class="custom-btn rekening primary"
              @click="onConfirmPayment"
              :disabled="loadingPayment"
            >
              <template v-if="loadingPayment">
                <b-spinner
                  small
                  type="border"
                  variant="light"
                  class="mr-2"
                  label="Loading..."
                ></b-spinner>
                Memproses...
              </template>
              <template v-else> Ya, Sudah </template>
            </button>
          </div>
        </div>
      </newCustomModal>
      <h2 v-if="loaded == false" class="text-center">
        <b-spinner variant="warning"></b-spinner>
      </h2>
      <b-pagination
        align="center"
        :total-rows="rowsPengajuan"
        :per-page="perPagePengajuan"
        aria-controls="pengajuan-table"
        v-model="currentPagePengajuan"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingAgency from "../../api/marketingAgency.js";
import moment from "moment";
import "moment/locale/id";
import NewCustomModal from "../newCustomModal.vue";

const biayaJasaFields = [
  { key: "id_transaksi", label: "ID Transaksi", sortable: false },
  { key: "month", label: "Bulan", sortable: true },
  { key: "details", label: "Jumlah Pengajuan", sortable: true },
  { key: "totals", label: "Total Pengajuan", sortable: true },
  { key: "biayas", label: "Total Ujrah", sortable: true },
  { key: "status", label: "Status", sortable: true },
  { key: "aksi", label: "Aksi", sortable: true },
];

export default {
  name: "BiayaJasaAgency",
  components: {
    NewCustomModal,
  },
  data() {
    return {
      biayaJasaItems: [],
      biayaJasaFields: biayaJasaFields,
      perPagePengajuan: 5,
      currentPagePengajuan: 1,
      confirmStatusModal: false,
      successModal: false,
      modalTitle: "",
      textModal: "",
      modalDocTitle: "",
      changingStatus: false,
      loaded: false,
      mitra_bank_id: "",
      bankOptions: [], // Opsi bank yang tersedia
      isLoading: false,
      emailNotificationModal: false, // Control for the success email notification modal
      errorNotificationModal: false, // Control for the error notification modal
      status_pengajuan_id: null,
      pengajuan_id: null,
      confirmRejectStatusModal: false,
      rejectModal: false,
      authSignUrl: null,
      isLoadingSign: null,
      modalAuthSignUrl: false,
      openDetailModal: false,
      dataModal: "",
      confirmPaymentModal: false,
      imagePayment: "",
      loadingPayment: false,
    };
  },
  computed: {
    rowsPengajuan() {
      return this.biayaJasaItems.length;
    },
  },
  mounted() {
    this.loadData();
    this.loadBankOptions();
  },
  methods: {
    loadData() {
      MarketingAgency.payments()
        .then((res) => {
          this.biayaJasaItems = res.data.data;
          this.loaded = true;
        })
        .catch((err) => console.log(err));
    },
    formatTanggal(tanggal) {
      if (!tanggal) return "-";
      return moment(tanggal).locale("id").format("DD MMMM YYYY HH:mm");
    },
    formatBulan(date) {
      if (!date) return "-";
      return moment(date).locale("id").format("MMMM YYYY");
    },
    applyDateFilter() {
      return;
    },
    openModal(data) {
      console.log("data  : ", data);
      this.dataModal = data;
      this.openDetailModal = true;
    },
    openModalConfirmPayments(data) {
      this.dataModal = data;
      this.imagePayment = this.dataModal.attachment.image_url;
      this.confirmPaymentModal = true;
    },
    onConfirmPayment() {
      const payload = { status: "approved" };
      this.loadingPayment = true;

      MarketingAgency.confirmationPayment(this.dataModal.id_transaksi, payload)
        .then((res) => {
          if (res.data.meta.code === 200) {
            this.$toast.success("Berhasil mengkonfirmasi pembayaran!");
            this.confirmPaymentModal = false;
            this.loadData();
          } else {
            this.$toast.error("Gagal mengkonfirmasi pembayaran.");
            this.confirmPaymentModal = false;
          }
        })
        .catch((err) => {
          console.error("Error confirming payment:", err);
          this.$toast.error(
            "Terjadi kesalahan saat mengkonfirmasi pembayaran."
          );
        })
        .finally(() => {
          this.loadingPayment = false;
        });
    },
    onRejectPayment() {
      const payload = { status: "rejected" };
      this.loadingPayment = true;

      MarketingAgency.confirmationPayment(this.dataModal.id_transaksi, payload)
        .then((res) => {
          if (res.data.meta.code === 200) {
            this.$toast.success(
              "Berhasil! Kami akan mengupload ulang gambar bukti pembayaran."
            );
            this.confirmPaymentModal = false;
            this.loadData();
          } else {
            this.$toast.error("Gagal mengkonfirmasi pembayaran.");
            this.confirmPaymentModal = false;
          }
        })
        .catch((err) => {
          console.error("Error confirming payment:", err);
          this.$toast.error(
            "Terjadi kesalahan saat mengkonfirmasi pembayaran."
          );
        })
        .finally(() => {
          this.loadingPayment = false;
        });
    },
  },
};
</script>

<style scoped>
.overflow-auto {
  overflow-x: auto;
  /* Mengaktifkan scroll horizontal */
  white-space: nowrap;
  /* Mencegah pembungkusan teks */
}

.b-table {
  min-width: 800px;
  /* Sesuaikan dengan lebar minimal yang Anda inginkan */
}
.btn-custom {
  background-color: #f6bc3c;
  color: #274c8f;
  border-radius: 5px;
}
.btn-custom:hover {
  background-color: #274c8f;
  color: #ffffff;
}
.cancel:hover {
  background-color: #fd0000;
  color: #ffffff;
}
.success:hover {
  background-color: #00b300;
  color: #ffffff;
}
.btn-disabled {
  background-color: #d5a031 !important;
  color: #ffffff !important;
  opacity: 1; /* Hilangkan efek transparan */
  cursor: not-allowed; /* Tetap tidak interaktif */
  pointer-events: none; /* Tidak bisa diklik */
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.title-modal {
  font-size: 20px;
  color: #274c8e;
  font-weight: 500;
}
.modal-action-buttons {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 30px;
}
.modal-action-buttons.no-rekening {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
.modal-action-buttons.wrong-modal {
  display: flex;
  justify-content: center; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
.custom-btn {
  background-color: #00a1ca;
  color: white !important;
  padding: 2rem 2rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}

.custom-btn.primary:disabled,
.custom-btn.primary[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.custom-btn.danger:disabled,
.custom-btn.danger[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.custom-btn.rekening {
  background-color: #00a1ca;
  color: white !important;
  padding: 1rem 2rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 400;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}

.custom-btn:hover {
  background-color: #008bb0;
}

.custom-btn.primary {
  background-color: #00a1ca;
}

.custom-btn.danger {
  background-color: #00a1ca;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/biaya-jasa-agency.vue